import {
  LocalPhone as LocalPhoneIcon,
  RoomService as RoomServiceIcon,
  MarkunreadMailbox as MarkunreadMailboxIcon,
  FolderShared as FolderSharedIcon,
  AlternateEmail as AlternateEmailIcon,
  ThumbUp as ThumbUpIcon,
} from '@mui/icons-material'

export interface QuestionData {
  text: string;
  notes: string;
  note_uuid: string | null;
}

export interface Employee {
  id: string;
  name: string;
  department?: string;
}

export const HANDLING_STATUS = {
  ANSWERED: 'answered',
  CALLBACK: 'callback',
  FORWARDED: 'forwarded',
  ABORTED: 'aborted',
} as const

export type HandlingStatus =
  (typeof HANDLING_STATUS)[keyof typeof HANDLING_STATUS];

export interface ActionFormProps {
  channel: string;
  questions: QuestionData[];
  status: string;
  caseUuid?: string | null;
  onSave: (data: {
    questions: QuestionData[];
    status: string;
    handlingType: HandlingStatus;
    employeeSearch?: string;
    employee_uuid?: string;
    case_type_uuid?: string;
    subject?: string;
    caseUuid?: string | null;
  }) => void;
  onQuestionsChange: (questions: QuestionData[]) => void;
  onLinkCase?: (caseUuid: string) => void;
}

export const STATUS_LABELS: Record<HandlingStatus, string> = {
  answered: 'Direct beantwoord',
  callback: 'Terugbelverzoek',
  forwarded: 'Doorgezet',
  aborted: 'Afgebroken',
}

export const STATUS_SHORT: Record<HandlingStatus, string> = {
  answered: 'Antw',
  callback: 'Bellen',
  forwarded: 'Door',
  aborted: 'Afbr',
}

export const STATUS_OPTIONS: HandlingStatus[] = [
  'answered',
  'callback',
  'forwarded',
  'aborted',
]

export const STATUS_TO_CASE_TYPE: Record<string, string | null> = {
  answered: null,
  callback: 'ed393d9c-be05-4b66-a597-f94d6d088c4a',
  forwarded: null,
  aborted: null,
}

export const channelIcons: Record<string, JSX.Element> = {
  phone: <LocalPhoneIcon sx={{ fontSize: 20 }} />,
  counter: <RoomServiceIcon sx={{ fontSize: 20 }} />,
  mail: <MarkunreadMailboxIcon sx={{ fontSize: 20 }} />,
  person: <FolderSharedIcon sx={{ fontSize: 20 }} />,
  email: <AlternateEmailIcon sx={{ fontSize: 20 }} />,
  social: <ThumbUpIcon sx={{ fontSize: 20 }} />,
}

export const channelLabels: Record<string, string> = {
  phone: 'Telefonisch contact',
  counter: 'Balie contact',
  mail: 'Post',
  person: 'Persoonlijk contact',
  email: 'E-mail contact',
  social: 'Social media',
}
